module.exports = __webpack_public_path__ + "img/ring_r_l_null_0@2x.78d84d98.png";